import React, { useEffect, useState } from "react";
import styles from "./StoreNotice.module.css";
import {
  getMarket, marketInfo, marketCurrency, storeNoticeDue, markStoreNoticed, wrongStoreHint, dismissWrongStoreHint, goToOwnStore,
} from "../../utils/market";
import { placeName } from "../../seo/brandPage";
import { currencyCode } from "../../utils/currency";
import { MarketSwitcher } from "../MarketSwitcher/MarketSwitcher";

/**
 * "Showing the United Kingdom store, prices in USD · Change", once per store,
 * the first time a store outside India is chosen for the visitor (Cloudflare's
 * country or a ?market= link). Marked seen as soon as it shows, so it never
 * follows them from page to page; "Change" opens the same store picker.
 */
export const StoreNotice = () => {
  // On another store's own page (/us/... opened from the UAE), the hint
  // replaces the notice: it names this store too, and offers the visitor's.
  const [hint, setHint] = useState(() => wrongStoreHint());
  const [show, setShow] = useState(() => !hint && storeNoticeDue());

  useEffect(() => {
    if (show) markStoreNoticed();
  }, [show]);

  if (hint) {
    const here = marketInfo(getMarket());
    return (
      <div className={styles.notice} role="status">
        <span className={styles.text}>
          {here.flag} This is the {here.label} store. Shopping from {placeName(hint.code)}?{" "}
          <button type="button" className={styles.link} onClick={() => goToOwnStore(hint.code)}>
            {hint.flag} See your store
          </button>
        </span>
        <button
          type="button"
          className={styles.close}
          onClick={() => {
            dismissWrongStoreHint();
            setHint(null);
          }}
          aria-label="Dismiss"
        >
          ×
        </button>
      </div>
    );
  }

  if (!show) return null;
  const info = marketInfo(getMarket());

  return (
    <div className={styles.notice} role="status">
      <span className={styles.text}>
        {info.flag} Showing the {info.label} store, prices in {currencyCode(marketCurrency(getMarket()))} ·{" "}
        <MarketSwitcher variant="link" label="Change" />
      </span>
      <button type="button" className={styles.close} onClick={() => setShow(false)} aria-label="Dismiss">
        ×
      </button>
    </div>
  );
};

export default StoreNotice;
